module.exports = __webpack_public_path__ + "img/clinic-round.0ae06472.svg";